import React from 'react';
import { Container, Row, Col }
from 'react-bootstrap';

function About() {
    return (
            <Container className="text-white mt-5">
                <Row className="mt-2">
                    <Col>
                    <div className="d-flex justify-content-start blur-section-red p-3 rounded">
                        <p>
                            Unser Ausbildungsprogramm zum Krav Maga Instructor ist intensiv, kompakt 
                            und herausfordernd – gleichzeitig aber auch äußerst motivierend. Nach erfolgreichem 
                            Bestehen der Abschlussprüfung wirst Du stolz den Titel KRAV MAGA INSTRUCTOR (full) 
                            tragen und bist qualifiziert, eigene Trainingsgruppen professionell anzuleiten. 
                            Unser erfahrenes Ausbilder-Team besteht aus hochrangigen Dan-Trägern, Großmeistern und 
                            Experten in den zivilen Bereichen Kampfkunst, Kampfsport, Selbstverteidigung und Taktischer Kontaktkampf (TSKM). 
                            Darüber hinaus sind sie allesamt zertifizierte Übungsleiter (b+c, DOSB). 
                            Erlebe eine Ausbildung auf höchstem Niveau, die Dir alle notwendigen Fähigkeiten vermittelt, 
                            um Krav Maga mit Leidenschaft und Kompetenz weiterzugeben.<br/>
                            Unser Ausbildungsprogramm richtet sich an Personen mit mindestens zwei Jahren 
                            Erfahrung im Krav Maga oder einer vergleichbaren Kampfsportart, die Tritt- und Schlagtechniken umfasst. 
                            Wir praktizieren Krav Maga in realistischen Kontaktformen, da wir überzeugt sind: Was sich im Sparring 
                            bewährt, wird auch im Ernstfall auf der Straße bestehen.
                        </p>                
                    </div>                
                    </Col>
                </Row>
            </Container>
            );
}

export default About;


